export const parisSeineMontmartreProgram = {
  programKey: 'paryz-sekwana-i-uliczki-montmartre',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Paryż - Sekwana i uliczki Montmartre',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Paryż:',
  stickySubtitle: 'Sekwana i uliczki Montmartre',

  pageUrl:
    'https://coolturystki.pl/wycieczki/paryz-sekwana-i-uliczki-montmartre',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-paryza-wieza-eiffla-sekwana-mvo56a0z.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-paryza-wieza-eiffla-sekwana-mvo56a0z.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Paryż'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-10-27',
  },

  /* Terminy: 30 kwietnia - 3 maja oraz 26 - 29 sierpnia 2027. */
  tripIds: [33, 34],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '33': {
      pilotId: 'paulina',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż odbywa się między Lotniskiem Chopina w Warszawie (WAW) a lotniskiem Charles’a de Gaulle’a w Paryżu (CDG).',
        },
        hotel: {
          title: 'Hotel 3★ w Paryżu',
          description:
            '3 noclegi w pokojach 2-osobowych w hotelu 3★ w dzielnicy Batignolles. W cenie są śniadania hotelowe.',
        },
      },
    },

    '34': {
      pilotId: 'marta',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż odbywa się między Lotniskiem Chopina w Warszawie (WAW) a lotniskiem Charles’a de Gaulle’a w Paryżu (CDG).',
        },
        hotel: {
          title: 'Hotel 3★ w Paryżu',
          description:
            '3 noclegi w pokojach 2-osobowych w hotelu 3★ w dzielnicy Batignolles. W cenie są śniadania hotelowe.',
        },
      },
    },
  },
}
